import {inject, Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {take} from 'rxjs';
import {ApiService} from './api.service';
import {CapabilitiesResource} from '../types/user/capabilitiesResource';
const createDefaultCapabilities = (): CapabilitiesResource => ({
  calendar: null,
  chat: null,
  contacts: null,
  communities: null,
  developer: null,
  home: {
    user_menu_management: false,
  },
  feedback: null,
  knowledgebase: null,
  meeting: null,
  news: null,
  profile: {
    show_company: false,
    show_mobile_number: false,
    show_telephone_number: false,
    show_email: false,
    edit_salutation: false,
    edit_name: false,
    edit_mobile_number: false,
    edit_telephone_number: false,
    edit_email: false,
  },
  settings: {
    global_settings: false,
    iam: {
      users: false,
      user_rights: false,
      user_password: false,
      groups: false,
      group_rights: false,
    }
  },
  workflow: null,
});

@Injectable({
  providedIn: 'root'
})
export class CapabilitiesService {
  private api: ApiService = inject(ApiService);

  private _capabilities: WritableSignal<CapabilitiesResource> = signal(createDefaultCapabilities());
  public capabilities: Signal<CapabilitiesResource> = this._capabilities.asReadonly();
  private _capabilitiesLoaded: WritableSignal<boolean> = signal(false);
  public capabilitiesLoaded: Signal<boolean> = this._capabilitiesLoaded.asReadonly();

  public loadUserCapabilities(): void {
    this.api.getUserCapabilities()
      .pipe(take(1))
      .subscribe({
        next: (capabilities: CapabilitiesResource) => {
          this._capabilities.set(capabilities);
          this._capabilitiesLoaded.set(true);
        },
        error: (error) => {
          this._capabilitiesLoaded.set(true);
          console.error('Error loading user capabilities:', error);
        }
      });
  }

  public resetCapabilities(): void {
    this._capabilities.set(createDefaultCapabilities());
    this._capabilitiesLoaded.set(false);
  }

  public hasCalendarRight(): boolean {
    const calendarCapabilities = this._capabilities().calendar;
    if (calendarCapabilities === null) {
      return false;
    } else {
      return true;
    }
  }
}
